import { useTranslation } from 'next-i18next';
import type {
  PronunciationModalContainerProps,
  VideoThumbStyle,
} from './pronunciation-modal.types';

export const usePronunciationModalPresenter = (
  props: PronunciationModalContainerProps,
) => {
  const { t } = useTranslation('common');
  const { hideModal, videoUrl, ipa, englishSound, status } = props;

  const videoEmbedUrl = `https://www.youtube.com/embed/${videoUrl}?rel=0&amp;modestbranding=1&amp;showinfo=0&amp;autoplay=1`;
  const coverUrl = `https://i.ytimg.com/vi/${videoUrl}/0.jpg`;
  const videoThumbStyle: VideoThumbStyle = {
    backgroundImage: `url(${coverUrl})`,
  };

  const getStatusText = (statusValue: number): string => {
    switch (statusValue) {
      case 1:
        return 'Weak';
      case 2:
        return 'Average';
      case 3:
        return 'Strong';
      default:
        return t('modals.pronunciation.status.noRating');
    }
  };

  return {
    ipa,
    englishSound,
    statusText: getStatusText(status),
    videoEmbedUrl,
    videoThumbStyle,
    onClose: hideModal,
  };
};
